import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

const billing_url = `${billing_expense.billing_expense_url}/${server.QUOTATIONS}`

export const billing_expense_getAllQuotationsByID = (id) => {
    return httpClient.get(`${billing_url}/${id}`);
};

// ✅ เพิ่ม params เพื่อรองรับ filter (doc_type, status, department_id, company_id, dateFrom, dateTo, keyword)
export const billing_expense_load_file = (id, company_id) => {
    return httpClient.get(`${billing_url}/billing-expense-load-file/${id}/${company_id}`);
};

export const billing_expense_getAllQuotations = (params = {}) => {
    return httpClient.get(`${billing_url}/`, { params });
};

export const billing_expense_addQuotations = (data) => {
    return httpClient.post(`${billing_url}/`, data);
};
export const billing_expense_upload_file = (data) => {
    return httpClient.post(`${billing_url}/billing-expense-upload-file`, data);
};


export const billing_expense_updateQuotations = (id, data) => {
    return httpClient.put(`${billing_url}/${id}`, data);
};
export const billing_expense_deleteQuotations = (id) => {
    return httpClient.delete(`${billing_url}/${id}`);
};

export const billing_expense_delete_file = ({ module_name, module_id, file_id, filename }) => {
    return httpClient.delete(`${billing_url}/billing-expense-delete-file`, {
        params: { module_name, module_id, file_id, filename },
    });
};

export const billing_expense_adjustQuotations = (company_id, params = {}) => {
    return httpClient.get(`${billing_url}/adjust-quotations/${company_id}`, { params });
};
